import React from "react";
import styled from "styled-components";
import { shareOnFacebook } from "../../../helpers";
import src from "./onboarding-share-with-friends-whatsapp.png";

const Container = styled.div`
    margin: 40px 0 0 0;
`;
const Img = styled.img`
    width: 266px;
    height: 106px;
`;

function onClick(e: React.MouseEvent<HTMLImageElement>) {
    e.preventDefault();
    e.stopPropagation();

    shareOnFacebook("https://urdupub.com/b-170-/");

    const { gtag } = window;
    gtag("event", "share", {
        event_category: "become-an-author",
    });

    return false;
}

export default function ShareOnWhatsApp() {
    return (
        <Container>
            <Img src={src} onClick={onClick} />
        </Container>
    );
}
